import { createFileRoute } from "@tanstack/react-router";
import AdminSchedulerPage from "@/admin/pages/scheduler";

export const Route = createFileRoute("/admin/scheduler")({
  component: AdminSchedulerPage,
});
